import { render, staticRenderFns } from "./ParentAboutUs.vue?vue&type=template&id=01b9a5f3&"
import script from "./ParentAboutUs.vue?vue&type=script&lang=js&"
export * from "./ParentAboutUs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports